const BASE_API = process.env.MIX_ENDLESS_API_URL
import { flare } from "@flareapp/js";

const state ={
	summerCampsList:[],
	summerCampsListData:[],
	summerCampsMeta:[],
	summerCampsLinks:{},
	summerCampsListError:null,
	summerCampsDetail:null,
	studentTypes:[],
	opportunities:[],
	coursesList:[],
}
const getters = {
	summerCampsListGetter:({summerCampsList}) => summerCampsList,
	summerCampsMetaGetter:({summerCampsMeta}) => summerCampsMeta,
	summerCampsLinksGetter:({summerCampsLinks}) => summerCampsLinks,
	summerCampsListData:({summerCampsListData}) => summerCampsListData,
	summerCampsDetailGetter:({summerCampsDetail}) => summerCampsDetail,
	studentTypesGetter:({studentTypes}) => studentTypes,
	opportunitiesGetter:({opportunities}) => opportunities,
	coursesListGetter:({coursesList}) => coursesList,
}

const mutations = {
	setSummerCampsList: (state,payload)=> {state.summerCampsList = payload},
	appendSummerCampsList: (state,payload)=> {state.summerCampsList = [...state.summerCampsList, ...payload]},
	setSummerCampsMeta: (state,payload)=> {state.summerCampsMeta = payload},
	setSummerCampsLinks: (state,payload)=> {state.summerCampsLinks = payload},
	setEmptySummerCampsList : (state,payload)=> state.summerCampsListData = [],
	setSummerCampsListSeeMore : (state,payload)=> state.summerCampsListData.push(...payload),
	setSummerCampsDetail: (state,payload)=> {state.summerCampsDetail = payload},
	setStudentTypes: (state,payload)=> {state.studentTypes = payload},
	setOpportunities: (state,payload)=> {state.opportunities = payload},
	setCoursesList: (state,payload)=> {state.coursesList = payload},
}

const actions = {
	async getSummerCampsList({commit,state}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses`,{params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			if (payload.append) {
				commit('appendSummerCampsList',res.data.result.data)
			} else {
				commit('setSummerCampsList',res.data.result.data)
			}
			commit('setSummerCampsMeta',res.data.result.meta)
			commit('setSummerCampsLinks',res.data.result.links)
		}).catch(err => {
			if (err.response) {
				state.summerCampsListError = err.response.status;
			} else {
				state.summerCampsListError = 'Unknown error or network issue';
				flare.createReport(err, {
					type: "UnknownError",
					context: "Error on Summer Camps List",
					message: err,
				});
			}
		})
	},
	async getSummerCampsDetail({commit}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses/${payload.courseId}`, {params:{...payload.filters},headers:{...payload.headers}}).then(res => {
			commit('setSummerCampsDetail',res.data.result)
		})
	},
	async getStudentTypes({commit}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses-student-types`, {headers:{...payload.headers}}).then(res => {
			commit('setStudentTypes',res.data.result)
		})
	},
	async getOpportunities({commit}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses-opportunities`, {headers:{...payload.headers}}).then(res => {
			commit('setOpportunities',res.data.result)
		})
	},
	async getCoursesList({commit}, payload){
		await this.$axios.get(`${BASE_API}/summer-camps-courses`, {params:{...payload.params}, headers:{...payload.headers}}).then(res => {
			commit('setCoursesList',res.data.result.data)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
